import { useState } from "react";

import DropDownMenu from "../common/DropDownMenu";
import { EUnitDetailsFilter } from "../../interfaces/interfaces";
import { ReactComponent as More } from "../../img/header/More.svg";
import { renderUnitDetailsElementAmount } from "../unitDetails/common/CommonUnitDetailsComponents";

export interface HomeDetailsMainInfoForSmallScreenProps {
  currentUnitDetailsFilter: EUnitDetailsFilter;
  numBrilliantDevices: number;
  numIntegrations: number;
  setUnitDetailsFilter: React.Dispatch<
    React.SetStateAction<EUnitDetailsFilter>
  >;
  openRemoveHomeModal: () => void;
}

const HomeDetailsMainInfoForSmallScreen: React.FC<
  HomeDetailsMainInfoForSmallScreenProps
> = ({
  currentUnitDetailsFilter,
  setUnitDetailsFilter,
  numBrilliantDevices,
  numIntegrations,
  openRemoveHomeModal,
}) => {
  const [dropDownMenuVisible, setDropDownMenuVisible] = useState(false);
  return (
    <div className="unit-main-container-small">
      <div className="unit-details-container unit-description-small">
        <button
          data-testid="brilliants-amount"
          className={`unit-description-small-info unit-details ${
            currentUnitDetailsFilter === EUnitDetailsFilter.brilliants
              ? "unit-details-selected"
              : ""
          }`}
          type="button"
          onClick={() => setUnitDetailsFilter(EUnitDetailsFilter.brilliants)}
        >
          {renderUnitDetailsElementAmount({
            nameOfSingleDevice: "Brilliant",
            numDevices: numBrilliantDevices,
          })}
        </button>
        <button
          data-testid="integrations-amount"
          className={`unit-description-small-info unit-details ${
            currentUnitDetailsFilter === EUnitDetailsFilter.integrations
              ? "unit-details-selected"
              : ""
          }`}
          type="button"
          onClick={() => setUnitDetailsFilter(EUnitDetailsFilter.integrations)}
        >
          {renderUnitDetailsElementAmount({
            nameOfSingleDevice: "Integration",
            numDevices: numIntegrations,
          })}
        </button>
        <button
          data-testid="residents-amount"
          className={`unit-description-small-info unit-details ${
            currentUnitDetailsFilter === EUnitDetailsFilter.residents
              ? "unit-details-selected"
              : ""
          }`}
          type="button"
          onClick={() => setUnitDetailsFilter(EUnitDetailsFilter.residents)}
        >
          <span style={{ opacity: 0 }} className="unit-details-number menu">
            0
          </span>
          Members
        </button>
        <div className="dashboard-settings-more">
          {dropDownMenuVisible && (
            <DropDownMenu>
              <button
                className="dashboard-settings-more-btn unit-description-small"
                type="button"
                onClick={() => {
                  openRemoveHomeModal();
                  setDropDownMenuVisible(false);
                }}
              >
                Remove from ProView
              </button>
            </DropDownMenu>
          )}
          <More
            className="dashboard-settings-more-svg"
            onClick={() => setDropDownMenuVisible(!dropDownMenuVisible)}
            title="More Button"
          />
        </div>
      </div>
    </div>
  );
};

export default HomeDetailsMainInfoForSmallScreen;
